import {
  DefaultReportsParamsApiFactory,
  DigitalSchoolsApiFactory,
  KnowledgeMonitoringApiFactory,
  MunicipalitiesApiFactory,
  MunicipalitySchoolsApiFactory,
  OlympiadsApiFactory,
  ParallelsSubjectsApiFactory,
  PretendsApiFactory,
  SchoolsApiFactory,
  UserApiFactory,
} from '../api/cabmun-api-public';
import {
  BannersApiFactory,
  FeaturesApiFactory,
  FeedbacksApiFactory,
  GratitudesApiFactory,
  MunicipalityTasksApiFactory,
  PopupsApiFactory,
  RegionIndicatorsApiFactory,
  SubjectSchoolsApiFactory,
  SurveysApiFactory,
  TeacherReviewsApiFactory,
  TsokApiFactory,
  WebinarsApiFactory,
} from '../api/cabmun-content-public';
import { baseUrl } from 'utils/api';

const fetchFactory = function (fetchOptions: RequestInit) {
  return async (input: RequestInfo | URL, options?: RequestInit) => {
    const header = options?.headers;
    /*
    https://www.w3.org/Protocols/rfc1341/7_2_Multipart.html
    При отправке формы требуется разделитель, который обычно проставляется автоматически.
    Наш сгенерированный клиент записывает заголовок content-type,
    что в дальнейшем не дает браузеру добавить разделитель  к этому же заголовку.
    Решением стало удаление заголовка content-type multipart/form-data из запроса,
    который отправлется из сгенерированного клиента
    */
    if (header instanceof Headers && header.get('content-type') === 'multipart/form-data') {
      header.delete('content-type');
    }

    return fetch(input as string, {
      ...options,
      ...fetchOptions,
    });
  };
};
export const apiFetch = fetchFactory({
  credentials: 'include',
});
const apiOptions = {};

export const DefaultReportsParamsApi = DefaultReportsParamsApiFactory(apiOptions, baseUrl, apiFetch);
export const MunicipalitySchoolsApi = MunicipalitySchoolsApiFactory(apiOptions, baseUrl, apiFetch);
export const ParallelsSubjectsApi = ParallelsSubjectsApiFactory(apiOptions, baseUrl, apiFetch);
export const DigitalSchoolsApi = DigitalSchoolsApiFactory(apiOptions, baseUrl, apiFetch);
export const MunicipalitiesApi = MunicipalitiesApiFactory(apiOptions, baseUrl, apiFetch);
export const TeacherReviewsApi = TeacherReviewsApiFactory(apiOptions, baseUrl, apiFetch);
export const OlympiadsApi = OlympiadsApiFactory(apiOptions, baseUrl, apiFetch);
export const PretendsApi = PretendsApiFactory(apiOptions, baseUrl, apiFetch);
export const WebinarsApi = WebinarsApiFactory(apiOptions, baseUrl, apiFetch);
export const BannersApi = BannersApiFactory(apiOptions, baseUrl, apiFetch);
export const PopupsApi = PopupsApiFactory(apiOptions, baseUrl, apiFetch);
export const UserApi = UserApiFactory(apiOptions, baseUrl, apiFetch);
export const KnowledgeMonitoringApi = KnowledgeMonitoringApiFactory(apiOptions, baseUrl, apiFetch);
export const SchoolsApi = SchoolsApiFactory(apiOptions, baseUrl, apiFetch);
export const SchoolsApiContent = SubjectSchoolsApiFactory(apiOptions, baseUrl, apiFetch);
export const TsokApi = TsokApiFactory(apiOptions, baseUrl, apiFetch);
export const SubjectSchoolsApi = SubjectSchoolsApiFactory(apiOptions, baseUrl, apiFetch);
export const FeedbacksApi = FeedbacksApiFactory(apiOptions, baseUrl, apiFetch);
export const SurveysApi = SurveysApiFactory(apiOptions, baseUrl, apiFetch);
export const RegionIndicatorsApi = RegionIndicatorsApiFactory(apiOptions, baseUrl, apiFetch);
export const GratitudesApi = GratitudesApiFactory(apiOptions, baseUrl, apiFetch);
export const MunicipalityTasksApi = MunicipalityTasksApiFactory(apiOptions, baseUrl, apiFetch);
export const FeaturesApi = FeaturesApiFactory(apiOptions, baseUrl, apiFetch);
